import { initGoogleAnalytics, initMonitor, initStory, initWebsite } from '@issuu/tracking-micro';

export type MonitorTracker = ReturnType<typeof initMonitor>;
export type WebsiteTracker = (
    events: Parameters<ReturnType<typeof initWebsite>>[0],
) => Promise<unknown>;
export type StoryTracker = (
    storyId: string,
    events: Parameters<ReturnType<typeof initStory>>[1],
) => Promise<void>;
export type GoogleAnalyticsTracker = ReturnType<typeof initGoogleAnalytics>;

let monitorTracker: MonitorTracker;
export const getMonitorTracker = (pingbackHost: string): MonitorTracker => {
    if (!monitorTracker) {
        monitorTracker = initMonitor({ pingbackHost });
    }
    return monitorTracker;
};

let websiteTracker: WebsiteTracker;
export const getWebsiteTracker = (pingbackHost: string, referrer: string): WebsiteTracker => {
    if (!websiteTracker) {
        const tracker = initWebsite({
            pingbackHost,
        });
        websiteTracker = events => tracker(events, undefined, referrer);
    }
    return websiteTracker;
};

let storyTracker: StoryTracker;
export const getStoryTracker = (pingbackHost: string, referrer: string): StoryTracker => {
    if (!storyTracker) {
        const tracker = initStory({
            pingbackHost,
        });
        storyTracker = (storyId, events) => tracker(storyId, events, referrer, 'web');
    }
    return storyTracker;
};

let googleAnalyticsTracker: GoogleAnalyticsTracker;
export const getGoogleAnalyticsTracker = (): GoogleAnalyticsTracker => {
    if (!googleAnalyticsTracker) {
        googleAnalyticsTracker = initGoogleAnalytics();
    }
    return googleAnalyticsTracker;
};
